import { c as _c } from "react/compiler-runtime";
export default function CreateWaveBackStep(t0) {
  const $ = _c(4);
  const {
    onPreviousStep
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-size-6 tw-mr-2 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t2 = <span>Previous</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onPreviousStep) {
    t3 = <button onClick={onPreviousStep} type="button" className={"tw-bg-transparent tw-text-iron-400 hover:tw-text-iron-50 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-px-6 tw-py-3 \n      tw-text-base tw-font-semibold tw-border tw-border-solid tw-border-transparent tw-rounded-lg tw-transition tw-duration-300 tw-ease-out"}>{t1}{t2}</button>;
    $[2] = onPreviousStep;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}